export const layerNames = {
    pollen: 'Contour.Observed.Pollen.Blur',
    airQuality: 'AirQuality',
    mapboxBoundaryLayer: 'admin-3-4-boundaries-bg'
};

export const tempUnits = {
    default: 'F',
    celsius: 'C',
    fahrenheit: 'F'
};

export const pressureUnits = {
    default: 'inHg',
    inchesMercury: 'inHg',
    millibars: 'mbar'
};

export const rainUnits = {
    default: 'in',
    millimeters: 'mm',
    inches: 'in'
};

export const speedUnits = {
    default: 'mph',
    kilometers: 'km/h',
    miles: 'mph',
    knots: 'knots',
    meters: 'm/s'
};

export const distanceUnits = {
    default: 'mi',
    kilometers: 'km',
    miles: 'mi'
}

export const unitSystems = {
    default: 'english',
    english: 'english'
};

export const mapboxLayerTypes = [
    'fill',
    'line',
    'symbol',
    'circle'
];

const mapLayouts = {
    icon: {
        'icon-image': 'unchosen-ic{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconTS: {
        'icon-image': 'unchosen-icTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconTD: {
        'icon-image': 'unchosen-icTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconSel: {
        'icon-image': 'chosen-ic{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconTSSel: {
        'icon-image': 'chosen-icTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconTDSel: {
        'icon-image': 'chosen-icTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPast: {
        'icon-image': 'unchosen-ic-past{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPastTS: {
        'icon-image': 'unchosen-ic-pastTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPastTD: {
        'icon-image': 'unchosen-ic-pastTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPastSel: {
        'icon-image': 'chosen-ic-past{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPastTSSel: {
        'icon-image': 'chosen-ic-pastTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    iconPastTDSel: {
        'icon-image': 'chosen-ic-pastTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIcon: {
        'icon-image': 'unchosen-ic{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIconTS: {
        'icon-image': 'unchosen-icTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIconTD: {
        'icon-image': 'unchosen-icTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIconSel: {
        'icon-image': 'chosen-ic{c}',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIconTSSel: {
        'icon-image': 'chosen-icTS',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    },
    currentIconTDSel: {
        'icon-image': 'chosen-icTD',
        'icon-allow-overlap': true,
        'icon-size': 0.33333,
        'text-size': 12,
        'text-offset': [0, 0]
    }
};

const mapStyles = {
    icon: {
        'text-color': '#000000'
    },
    forecastTrack: {
        'line-width': 2,
        'line-dasharray': [2, 2],
        'line-color': '#FFFFFF'
    },
    historicalTrack: {
        'line-width': 2,
        'line-color': '#FFFFFF'
    },
    forecastCone: {
        'fill-color': '#000000',
        'fill-opacity': 0.5
    }
};

export interface StyleType {
    [key: string]: string | number;
}

interface LayoutType {
    [key: string]: string | boolean | number | number[];
}

export interface featureMap {
    type: string;
    id: string;
    filter: (string | (string | number)[])[];
    style:  StyleType;
    layout?: LayoutType;
}

export const featureMappingService = (pointNotSelectedCondition: (string | number)[], pointSelectedCondition: (string | number)[]) => {
    const featureMapping: featureMap[] = [
        {
            type: 'fill',
            id: 'forecastCone',
            filter: ['all', ['==', 'dtype', 6]],
            style: mapStyles.forecastCone
        },
        {
            type: 'line',
            id: 'forecastTrack',
            filter: ['all', ['==', 'dtype', 5]],
            style: mapStyles.forecastTrack
        },
        {
            type: 'line',
            id: 'historicalTrack',
            filter: ['all', ['==', 'dtype', 2]],
            style: mapStyles.historicalTrack
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointHurricane',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 1], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPast
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointTS',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 1], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPastTS
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointTD',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 1], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPastTD
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointHurricaneSel',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 1], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPastSel
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointTSSel',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 1], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPastTSSel
        },
        {
            type: 'symbol',
            id: 'historicalTrackPointTDSel',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 1], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconPastTDSel
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointHurricane',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 4], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.icon
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointTS',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 4], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconTS
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointTD',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 4], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconTD
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointHurricaneSel',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 4], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconSel
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointTSSel',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 4], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconTSSel
        },
        {
            type: 'symbol',
            id: 'forecastTrackPointTDSel',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 4], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.iconTDSel
        },
        {
            type: 'symbol',
            id: 'currentTrackPointHurricane',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 3], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIcon
        },
        {
            type: 'symbol',
            id: 'currentTrackPointTS',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 3], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIconTS
        },
        {
            type: 'symbol',
            id: 'currentTrackPointTD',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 3], pointNotSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIconTD
        },
        {
            type: 'symbol',
            id: 'currentTrackPointHurricaneSelected',
            filter: ['all', ['==', 't', 1], ['==', 'dtype', 3], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIconSel
        },
        {
            type: 'symbol',
            id: 'currentTrackPointTSSelected',
            filter: ['all', ['in', 't', 4, 7, 10], ['==', 'dtype', 3], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIconTSSel
        },
        {
            type: 'symbol',
            id: 'currentTrackPointTDSelected',
            filter: ['all', ['in', 't', 3, 6, 9], ['==', 'dtype', 3], pointSelectedCondition],
            style: mapStyles.icon,
            layout: mapLayouts.currentIconTDSel
        }
    ];

    return featureMapping;
}